import BaseView from '../templates-base';
import FormatFactory from '../../../../factory/formats';
import DesygnerCompanyFactory from '../../../../factory/desygner-company';
import BrandTemplateThumbnailView from '../../components/thumbnail/restricted';

const CompanyInstance = require('../../../../factory/company').instance;
const CompanyFactory = require('../../../../factory/company').factory;

module.exports = BaseView.extend({
  fetchType: 'brand',
  initialize: function (options) {
    this.tool = INKIVE.Tool.getInstance();
    this.canvas = this.tool.editor.canvas;

    options.format && BaseView.prototype.initialize.call(this, options);
    options.format || FormatFactory.getCurrentFormat().then(_.bind(function (format) {
      return this.getSimilarFormat({ format: format }).then(_.bind(function (format) {
        options.format = format;
        BaseView.prototype.initialize.call(this, options);
      }, this));
    }, this));
  },

  getSimilarFormat: function (options) {
    const deferred = $.Deferred();
    const getClosestFormat = _.bind(getCF, this);

    options.format && deferred.resolve(options.format);
    if (!options.format) {
      this.isCustomFormat = true;
      FormatFactory.getFormats().then(function (formats) {
        return deferred.resolve(getClosestFormat(formats));
      });
    }

    return deferred.promise();

    function getCF (formats) {
      let format;
      let sizeDifference = Infinity;
      let ratioDifference = Infinity;
      const width = this.canvas.contentW;
      const height = this.canvas.contentH;
      const ratio = width / height;

      _.each(formats, function (f) {
        const pixelFormat = convertToPixels(f);
        const rd = Math.abs(ratio - pixelFormat.ratio);
        if (rd < ratioDifference) {
          const sd = Math.abs(width - pixelFormat.width) + Math.abs(height - pixelFormat.height);
          if (sd < sizeDifference) {
            format = f;
            sizeDifference = sd;
            ratioDifference = rd;
          }
        }
      });

      return format;

      function convertToPixels (format) {
        const w = INKIVE.Helpers.convertUnitsToPixels(format.width, format.unit);
        const h = INKIVE.Helpers.convertUnitsToPixels(format.height, format.unit);

        return _.extend(format, { width: w, height: h, ratio: w / h });
      }
    }
  },

  loadData: function (repeat, end) {
    this.end = end;
    this.repeat = repeat;

    this.companyInstance = this.format.external ? new CompanyFactory(this.format.external) : CompanyInstance;

    this.templateData && onceReadyToLoad.call(this);
    this.templateData || this.preloadData()
      .then(_.bind(function (formatData) {
        this.format = this.format || formatData;
        onceReadyToLoad.call(this);
      }, this));

    function onceReadyToLoad () {
      const isBrandFetch = this.fetchType === 'brand';
      INKIVE.Modal.togglePageLoader(true);

      // TODO: add pagination
      isBrandFetch && this.fetchBrandTemplates();
      isBrandFetch || this.fetchDesygnerTemplates();
    }
  },

  preloadData: function () {
    let formatData;

    return _.bind(loadDesignData, this)()
      .then(_.bind(loadTemplateData, this))
      .then(_.bind(loadFormat, this));

    function loadDesignData () {
      return this.companyInstance.get(['designs', INKIVE.C.BOOK.encodedId]);
    }

    function loadTemplateData (design) {
      formatData = design.format;

      return design.template
        ? this.companyInstance.get(['templates', design.template])
        : resolve({});
    }

    function loadFormat (templateData) {
      this.templateData = templateData;
      return formatData
        ? resolve(formatData)
        : this.companyInstance.get(['formats', templateData.format]);
    }

    function resolve (data) {
      const deferred = $.Deferred();
      deferred.resolve(data);
      return deferred.promise();
    }
  },

  fetchBrandTemplates: function () {
    return this.companyInstance.get(['formats', this.format.id, 'templates'])
      .then(_.bind(function (templates) {
        INKIVE.Modal.togglePageLoader(false);
        this.fetchType = 'desygner';

        this.appendBrandThumbnails(_.filter(templates, function (t) {
          return !t.is_draft;
        }));

        this.repeat();
      }, this));
  },

  fetchDesygnerTemplates: function () {
    this.format.parent_format
      ? DesygnerCompanyFactory.get(
        ['formats', this.format.parent_format, 'templates']
      ).then(_.bind(function (templates) {
        INKIVE.Modal.togglePageLoader(false);
        this.appendBrandThumbnails(templates);
        onEnd.call(this);
      }, this))
      : onEnd.call(this);

    function onEnd () {
      INKIVE.Modal.togglePageLoader(false);
      this.scrollRefresh();
      this.end();
    }
  },

  appendBrandThumbnails: function (templates) {
    const $scrollDetect = this.$el.find('.thumbnail-wrapper .scrollDetect');

    _.each(templates, function (template) {
      const $thumbnailView = $('<li>').addClass('thumbnail image loading')
        .data('key', 'brand-' + template.id)
        .insertBefore($scrollDetect);

      new BrandTemplateThumbnailView({
        el: $thumbnailView,
        width: this.columnWidth,
        format: this.format,
        baseTemplate: template,
        openSet: this.templateData.id === template.id
      });
    }, this);
  }
});
